import React from 'react';
import { injectIntl } from 'react-intl';
import { intlShape } from 'common/components/intl/intlShape';
import { Field } from 'redux-form';
import classNames from 'classnames';

import {
  messageTranslator,
  TRANSLATED_CLASS,
  MISSING_CLASS,
  translationIsMissing,
} from 'common/components/Intl';

const translatableProps = [
  'label',
  'labelText',
  'placeholder',
  'noResultsText',
];

const TranslatedField = ({ intl, className, ...props }) => {
  let missingMessage = false;
  const translate = messageTranslator(intl);

  const translatedProps = translatableProps
    .filter(p => props[p])
    .reduce((acc, cur) => {
      const prop = props[cur];
      const translatedMessage = translate(prop);
      acc[cur] = translatedMessage;

      if (translationIsMissing(translatedMessage, prop)) {
        missingMessage = true;
      }
      return acc;
    }, {});

  return (
    <Field
      className={classNames(className, TRANSLATED_CLASS, {
        [MISSING_CLASS]: missingMessage,
      })}
      {...props}
      {...translatedProps}
    />
  );
};

TranslatedField.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(TranslatedField);
